// extracted by mini-css-extract-plugin
export default {"shopContainer":"Shop_shopContainer__LUMbt","productsContainer":"Shop_productsContainer__5N5D7","orderSummeryContainer":"Shop_orderSummeryContainer__Cqk-5"};